<div
  class="grid grid-cols-2 justify-between gap-4 pb-1 md:grid md:justify-between"
>
  <h2
    style="transform: translate(0px, 4px)"
    class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Mobile App Users
  </h2>

  <!-- <button
    (click)="addCustomerDropdown.toggle()"
    type="button"
    mango-button
    class=""
  >
    + Add customer
  </button> -->

  <app-dropdown
    *appHasPermission="['create_user', 'create_coroporate']"
    class="w-fit justify-self-end text-nowrap"
    [id]="'addCustomerDropdown'"
    [buttonTitle]="'+ Add customer'"
    [actionList]="registerationDropdownActions()"
  ></app-dropdown>
</div>

<div 
  *appHasPermission="'view_profile_list'"
  class="grid gap-5 lg:grid-cols-3">
  <div class="rounded-md bg-[#EEF4FF] p-[38px] shadow-sm">
    <!-- Your chart component goes here -->
    <div>
      <p class="text-">Total Customers</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">{{ totalCount$ | async | number }}</h1>
    </div>
  </div>
  <div class="rounded-md bg-[#FFF6E8] p-[38px] shadow-sm">
    <!-- Your chart component goes here -->
    <div>
      <p>Fully Registered Customers</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">15</h1>
    </div>
  </div>
  <div
    class="flex items-center rounded-md bg-[#E5FFE6] p-[38px] shadow-sm sm:inline-flex"
  >
    <!-- Your chart component goes here -->

    <div>
      <div>
        <p>Active Now</p>
      </div>
      <div>
        <h1 class="number-stat-font text-4xl">15</h1>
      </div>
    </div>

    <!-- images at the End (Right) -->

    <div class="ml-auto flex">
      <div class="relative h-9 w-9 overflow-hidden rounded-full">
        <img
          class="h-full w-full bg-black object-cover"
          src="assets/images/man--small.png"
          alt="Image 1"
        />
      </div>
      <div class="relative -ml-3 h-9 w-9 overflow-hidden rounded-full">
        <img
          class="h-full w-full bg-black object-cover"
          src="assets/images/man--small.png"
          alt="Image 2"
        />
      </div>
      <div class="relative -ml-3 h-9 w-9 overflow-hidden rounded-full">
        <img
          class="h-full w-full bg-black object-cover"
          src="assets/images/man--small.png"
          alt="Image 3"
        />
      </div>
      <div class="relative -ml-3 h-9 w-9 overflow-hidden rounded-full">
        <img
          class="h-full w-full bg-black object-cover"
          src="assets/images/man--small.png"
          alt="Image 4"
        />
      </div>
    </div>
  </div>
</div>

<div class="flex gap-3">
  <!-- Search Input and Filters -->
  <app-filters *appHasPermission="'view_profile_list'" [filters]="filterStructure"></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'mobileUsers'"></app-table-refresh>
</div>

@if (isFetchingCustomerList$ | async) {
<div *appHasPermission="'view_profile_list'" class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}



<!-- Client Table -->
 @if (!(isFetchingCustomerList$ | async)) {
<div
  *appHasPermission="'view_profile_list'"
  style="
    border-radius: 0.5rem;
    border: 1px solid var(--Gray-200, #eaecf0);
    background: var(--Base-White, #fff);
    margin-top: 0.94rem;
  "
>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                S/N
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                User
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                Phone Number
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                Email
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                Role
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                Status
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                Profile Status
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
              </th>

              <!-- <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              ></th> -->
            </tr>
          </thead>
          <tbody>
            @for (user of userList$ | async; track user.id; let i = $index) {
              <tr>
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p>{{ i + 1 }}</p>
                </td>
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ user.first_name | titlecase }}
                    {{ user.middle_name | titlecase }}
                    {{ user.last_name | uppercase }}
                  </p>
                </td>
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ user.phone_number_1 || '-' }}
                  </p>
                </td>
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ user.email }}
                  </p>
                </td>
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">Customer</p>
                </td>
                <td
                  class="border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                >
                  <span
                    class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 {{
                        user.status === 'activated'
                          ? 'bg-green-200'
                          : 'bg-orange-300'
                      }} opacity-50 rounded-full"
                    ></span>
                    <span
                      class="relative flex  {{
                        user.status === 'activated'
                          ? 'text-[#027A48]'
                          : 'text-orange-700'
                      }} sm:text-[11px]"
                    >
                      {{ user.status | uppercase }}</span
                    >
                  </span>
                </td>
                <td
                  class="border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                >
                  <span
                    class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 {{
                        getProfileAccessStatus(user) === 'Unrestricted'
                          ? 'bg-green-200'
                          : 'bg-orange-300'
                      }} opacity-50 rounded-full"
                    ></span>
                    <span
                      class="relative flex  {{
                        getProfileAccessStatus(user) === 'Unrestricted'
                          ? 'text-[#027A48]'
                          : 'text-orange-700'
                      }} sm:text-[11px]"
                    >
                      {{ getProfileAccessStatus(user) | uppercase }}</span
                    >
                  </span>
                </td>
                 <td
                    class="relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                  >
                    <div
                      class="relative inline-block w-fit cursor-pointer border-gray-200 bg-white text-left"
                    >
                      <app-dropdown
                        [id]="user.id"
                        [actionList]="initDropdownList(user)"
                      >
                      </app-dropdown>
                    </div>
                  </td>
              </tr>
            }
          </tbody>
        </table>
        <app-table-navigator
          *ngIf="totalCount$ | async as totalCount"
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        ></app-table-navigator>
      </div>
    </div>
  </div>
</div>
}

<router-outlet></router-outlet>
